// Vendor imports
const { connect } = require('react-redux')
// Common client-v2 imports
const ImmutableToJS = require('client-v2/common/components/immutable-to-js')
const articleModelConnect = require('client-v2/common/models/article/connect')
const collectionActions = require('client-v2/common/models/collection/actions')
const userActions = require('client-v2/common/models/user/actions')
const deferDispatch = require('client-v2/common/state/dispatch')
const { FetchStateEnum } = require('client-v2/common/utils/enums')
// Container state imports
const { getSlide } = require('../state/selectors')
const articleProfileSlideActions = require('../state/slide-actions')
// Sibling imports
const ArticleProfileCollections = require('./collections-dumb')

function mapStateToProps() {
  return function (state, props) {
    const slide = getSlide(state, props)
    const isMoreLoading = [
      FetchStateEnum.EMPTY,
      FetchStateEnum.LOADING
    ].includes(slide.collectionsState)
    const isMoreAvailable = !isMoreLoading && !!slide.collectionsMeta.get('nextUrl')
    return {
      // Flags
      isMoreAvailable,
      isMoreLoading,
      // Values
      article: slide.article,
      items: slide.collectionsItems
    }
  }
}

function mapDispatchToProps(dispatch, props) {
  const { dispatchAction } = deferDispatch(dispatch)
  return {
    ...articleModelConnect.mapDispatchToProps(dispatch),
    onCollectionNavigate: dispatchAction(collectionActions.navigateToCollectionProfile),
    onLoadMore: dispatchLoadCollections(dispatch, props),
    onUserNavigate: dispatchAction(userActions.navigateToUserProfile)
  }
}

function dispatchLoadCollections(dispatch, props) {
  return function () {
    dispatch(function (dispatch, getState) {
      const slide = getSlide(getState(), props)
      const { article, collectionsMeta, collectionsState } = slide
      const isAlreadyLoading = collectionsState === FetchStateEnum.LOADING
      const nextUrl = collectionsMeta.get('nextUrl')
      if (!isAlreadyLoading && nextUrl) {
        dispatch(articleProfileSlideActions.loadCollections({ article, nextUrl }))
      }
    })
  }
}

// Exports

const SmartComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ImmutableToJS(
    ArticleProfileCollections
  )
)

module.exports = SmartComponent
